import { useGetPackagingLimits } from 'Features/accountSettings/api/getPackagingLimits'
import { useMemo } from 'react'

export const useIsTrialSubscription = () => {
  const { data } = useGetPackagingLimits()

  const isTrialSubscription = useMemo(() => {
    const { trialDaysLeft, productName } = data || {}
    return !!trialDaysLeft && !productName
  }, [data])

  return isTrialSubscription
}
